import { useEffect, useState } from "react";

const useHistoryBackContralOverlayState = (initialState: boolean) => {
    const [isOpen, setIsOpen] = useState<boolean>(initialState);
    
    const openOverlay = () => {
        window.history.pushState({ modal: true }, "");
        setIsOpen(true);
    };

    const closeOverlay = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        window.addEventListener("popstate", closeOverlay);

        return () => {
            window.removeEventListener("popstate", closeOverlay);
        };
    }, []);

    return({
        isOpen,
        openOverlay,
        closeOverlay
    })
}

export default useHistoryBackContralOverlayState;